export default __webpack_public_path__ + "paag-logo.a86c7726f73934741e6497381dd31faf.jpg";